<!-- Header: title left, current battery type centred, timestamp and refresh right -->
<div class="d-flex align-items-center">
    <p class="fw-semibold mb-1 avs-fuelcell-header-side">Batterie</p>
    <div class="d-flex justify-content-center">
        <span *ngIf="!isConfigUnavailable; else batteryUnavailableTitle" [class.avs-fuelcell-stale]="!isEditable">
            {{ getBatteryTypeString(currentBatType) }}</span>
        <ng-template #batteryUnavailableTitle>
            <span class="text-secondary">steht nicht zur Verfügung – Softwareupdate erforderlich</span>
        </ng-template>
    </div>
    <div class="d-flex align-items-center justify-content-end avs-fuelcell-header-side">
        <span *ngIf="data?.time" class="text-secondary small">Stand {{ data?.time | date: 'dd.MM.yyyy H:mm' }}</span>
        <img class="avs-icon-edit ms-2" role="button" height="20" src="assets/icons/arrow-clockwise.svg"
            alt="Aktualisieren" title="Aktualisieren" (click)="load()">
    </div>
</div>
<p *ngIf="information" class="text-danger small mb-1">{{ information }}</p>
<p *ngIf="isBusy" class="text-secondary small mb-1">{{ busyMessage }}</p>
<ng-container *ngIf="!isConfigUnavailable">
    <!-- Change battery type, collapsed -->
    <div class="mt-2" [class.avs-fuelcell-stale]="!isEditable">
        <div class="d-flex align-items-center avs-fuelcell-collapse-toggle" role="button"
        [attr.aria-expanded]="isBatTypeExpanded" title="Batterietyp ändern ein- oder ausklappen" (click)="isBatTypeExpanded = !isBatTypeExpanded">
        <img height="12" alt="" [src]="isBatTypeExpanded ? 'assets/icons/caret-down.svg' : 'assets/icons/caret-right.svg'">
        <span class="ms-1">Batterietyp ändern</span>
    </div>
        <div class="d-flex justify-content-between align-items-center mt-1" *ngIf="isBatTypeExpanded">
            <mat-form-field>
                <mat-label>Batterietyp</mat-label>
                <mat-select [(ngModel)]="selectedBatType" name="batType" [disabled]="!isEditable">
                    <mat-option *ngFor="let batteryType of batteryTypes" [value]="batteryType.type">
                        {{ batteryType.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button class="btn btn-outline-success rounded-0 ms-2" type="button"
                [disabled]="!isEditable || selectedBatType === undefined || selectedBatType === currentBatType"
                (click)="onChangeBatteryTypeClicked()">Speichern</button>
        </div>
    </div>

    <!-- Load parameters, collapsed -->
    <div class="mt-2" [class.avs-fuelcell-stale]="!isEditable">
        <div class="d-flex align-items-center avs-fuelcell-collapse-toggle" role="button"
        [attr.aria-expanded]="isLoadConfigExpanded" title="Ladeparameter ein- oder ausklappen" (click)="isLoadConfigExpanded = !isLoadConfigExpanded">
        <img height="12" alt="" [src]="isLoadConfigExpanded ? 'assets/icons/caret-down.svg' : 'assets/icons/caret-right.svg'">
        <span class="ms-1">Ladeparameter</span>
    </div>
        <ng-container *ngIf="isLoadConfigExpanded">
            <p *ngIf="isLoaded && rows.length < 1" class="text-secondary small mb-0">Keine Ladeparameter gemeldet.</p>
            <div *ngIf="rows.length > 0" class="row text-secondary small mt-1 pb-1 border-bottom border-danger">
                <div class="col-5">Parameter</div>
                <div class="col-4">Wert</div>
                <div class="col-3">Bereich / Standard</div>
            </div>
            <div class="row align-items-center border-bottom" *ngFor="let row of rows">
                <div class="col-5">{{ row.label }}<span *ngIf="row.unit" class="text-secondary ms-1">[{{ row.unit }}]</span></div>
                <div class="col-4">
                    <input class="form-control form-control-sm rounded-0" type="number" [min]="row.data.minVal"
                        [max]="row.data.maxVal" [(ngModel)]="row.value" [disabled]="!isEditable || isValueFixed(row)"
                        [ngClass]="{ 'is-invalid': isValueChanged(row) && !isValueValid(row), 'avs-fuelcell-fixed-value': isValueFixed(row) }">
                </div>
                <div class="col-3 small text-secondary d-flex align-items-center justify-content-between">
                    <span>{{ row.data.minVal }} – {{ row.data.maxVal }} / {{ row.data.defVal }} {{ row.unit }}</span>
                    <img class="avs-icon-edit ms-1" role="button" height="16" src="assets/icons/arrow-repeat.svg"
                        alt="Standardwert" title="Standardwert übernehmen"
                        *ngIf="isEditable && !isValueFixed(row) && row.value !== row.data.defVal"
                        (click)="onResetRowClicked(row)">
                </div>
            </div>
            <div class="d-flex justify-content-between mt-3">
                <button class="btn btn-outline-danger rounded-0" type="button" [disabled]="!isEditable"
                    (click)="onResetClicked()">Auf Werkseinstellungen zurücksetzen</button>
                <button class="btn btn-outline-success rounded-0" type="button"
                    [disabled]="!isEditable || !isLoadConfigSendable"
                    (click)="onSaveLoadConfigClicked()">Speichern</button>
            </div>
        </ng-container>
    </div>
</ng-container>
